/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX bff-patient API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const BffPatientPatientReceptionImageTypename = "BffPatientPatientReceptionImage" as const;

/**
 *
 * @export
 * @interface BffPatientPatientReceptionImage
 */
export interface BffPatientPatientReceptionImage {
  /**
   * 受付コードの有効期限
   * @type {Date}
   * @memberof BffPatientPatientReceptionImage
   */
  expiredAt: string;
  /**
   * 　受付コード画像のBase64データ
   * @type {string}
   * @memberof BffPatientPatientReceptionImage
   */
  image: string;
  /**
   * 受付コードのMIMEタイプ
   * @type {string}
   * @memberof BffPatientPatientReceptionImage
   */
  mimeType: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof BffPatientPatientReceptionImage
   */
  readonly __typename?: string;
}

export function BffPatientPatientReceptionImageFromJSON(json: any): BffPatientPatientReceptionImage {
  return BffPatientPatientReceptionImageFromJSONTyped(json, false);
}

export function BffPatientPatientReceptionImageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BffPatientPatientReceptionImage {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: BffPatientPatientReceptionImageTypename,

    expiredAt: json["expired_at"],
    image: json["image"],
    mimeType: json["mime_type"],
  };
}

export function BffPatientPatientReceptionImageToJSON(object?: BffPatientPatientReceptionImage | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    expired_at: tzDate(value.expiredAt).format(),
    image: value.image,
    mime_type: value.mimeType,
  };
}
